/* eslint-disable max-len */
import { Box, Typography } from "@mui/material";
import { CentralLoadingIndicator, MapMini } from "..";
/* eslint-disable no-unused-vars */
import React, { FC, useEffect, useState } from "react";

import { BoldSubHeaderText } from "../../styles/styledComponents/Header.styled";
import HomeHospitalDetails from "./HomeHospitalDetails";
import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";
import { LOCATIONS_URL } from "../../config/params";
import { useHospitalList } from "../../services/edit-hospital-location/edit-hospital-location.service";
import { useUpdateLocationStore } from "../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { useUserDetail } from "../../services/user-detail/user-detail.service";
import { useHospitalDetailsListStore } from "../../hooks/redux-hooks/hospital-details-list-store/hospital-details-list-store";

type IHomeHospitalContainerProps = {
  setHospitalDetailsContent?: (content: any) => void;
}

const HomeHospitalContainer: FC<IHomeHospitalContainerProps> = (props) => {
  const { setHospitalDetailsContent } = props;
  const { setLocationSelected: setLocationSelectedStore } = useUpdateLocationStore();
  const [isBubble, setIsBubble] = useState<boolean>(false);
  const { metroLocations, loading, getMetroLocations, currentLocation } = useHospitalList();
  const { setCurrentLocation, setHospitalList, setIsHospitalListUpdated, currentLocation: currentHospitalLocation, hospitalDetailsList, isHospitalListUpdated } = useHospitalDetailsListStore();
  const [markers, setMarkers] = useState<any[]>([]);
  const [mapData, setMapData] = useState<any>({});
  const [currentLocationContact, setCurrentLocationContact] = useState<string>("");
  const { user, loading: userLoading } = useUserDetail();

  const [selectedLocation, setSelectedLocation] = useState<{ location: any } | null>(null);
  const [listLocations, setListLocations] = useState<any[]>();

  const handleMarkerClick = (mark: any) => {
    setIsBubble(true);
    setSelectedLocation(mark);
    setMapData(mark.position);
  };

  const handleUpdateLocationDetail = (selectedLocation: ILocationItemResponse) => {
    setLocationSelectedStore([selectedLocation]);
  };

  useEffect(() => {
    if (user) {
      // only call the getMetrolocations api if the store is not updated with the details
      !isHospitalListUpdated && getMetroLocations();
      setIsBubble(false);
    }
  }, [user]);


  useEffect(() => {
    if (metroLocations) {
      setHospitalList(metroLocations); // update hospitalList once getMetrolocations api is called initially
      const currentLocationItem = metroLocations?.find((item) => item?.idLocation === currentLocation);

      if (currentLocationItem) {
        setMarkers([currentLocationItem]);
        setMapData({ lat: currentLocationItem.position?.lat, lng: currentLocationItem.position?.lng });
      }

      setListLocations(metroLocations);
    }
  }, [metroLocations]);

  useEffect(() => {
    if (isHospitalListUpdated && hospitalDetailsList) {
      const currentLocationItem = hospitalDetailsList?.find((item: any) => item?.idLocation === currentHospitalLocation);

      if (currentLocationItem) {
        setMarkers([currentLocationItem]);
        setMapData({ lat: currentLocationItem.position?.lat, lng: currentLocationItem.position?.lng });
      }

      setListLocations(hospitalDetailsList);
    }
  }, []);

  useEffect(() => {
    if (isHospitalListUpdated && listLocations) {
      const currentLocationItem = listLocations.find(
        (item) => item?.idLocation === currentHospitalLocation);

      if (currentLocationItem) {
        setCurrentLocationContact(currentLocationItem.phoneNumber);
      }
    }
  }, [listLocations]);
  useEffect(() => {
    if (listLocations && currentLocation) {
      setCurrentLocation(currentLocation); // update current location id once getMetrolocations api is called initially
      setIsHospitalListUpdated(true); // flag updated to reflect the hospital list details store has been updated
      const currentLocationItem = listLocations.find(
        (item) => item?.idLocation === currentLocation);

      if (currentLocationItem) {
        setCurrentLocationContact(currentLocationItem.phoneNumber);
      }
    }
  }, [currentLocation, listLocations]);

  if (userLoading || loading) {
    return <CentralLoadingIndicator />;
  }

  return (
    <>
      {mapData && Object.keys(mapData).length > 0 ?
        <Box className="flex flex-col gap-2">
          <Box className="flex justify-between items-end">
            <BoldSubHeaderText className="capitalize">Home Hospital</BoldSubHeaderText>
            <Typography variant="body1" sx={{ color: (theme) => theme.palette.gray.dark }}>
              <a href={LOCATIONS_URL}
                target="_blank" rel="noreferrer">
              All Locations</a>
            </Typography>
          </Box>
          <Box className="border border-1 overflow-hidden">
            <MapMini
              lat={mapData?.lat}
              lng={mapData?.lng}
              markers={markers}
              mapData={mapData}
              onClick={handleMarkerClick}
              isBubble={isBubble}
              location={selectedLocation}
              setIsBubble={setIsBubble}
              handleUpdateLocationDetail={handleUpdateLocationDetail}
              width="100%"
              zoom={14}
            />
          </Box>
          {user?.location?.locationName && <HomeHospitalDetails locationName={user?.location?.locationName}
            setHospitalDetailsContent={setHospitalDetailsContent}/>}
        </Box> : null}
    </>
  );
};

export default HomeHospitalContainer;
